class Customer.Reports.UserAndGroupFilterView extends Backbone.View
  template: JST["backbone/templates/customer/filters/user_and_group_filter"]

  events:
    'click #btnLeft': 'removeSelectedUsers'
    'click #btnRight': 'addSelectedUsers'
    'click #btnDoubleRight': 'addExpandedUsers'
    'click #btnDoubleLeft': 'removeExpandedUsers'
    'click #massive-add': 'addAllUsers'
    'click #massive-remove': 'removeAllUsers'
    'input #user-and-group-to-select .user-and-group-search--input': 'searchUsersToSelect'
    'input #user-and-group-selection .user-and-group-search--input': 'searchSelectedUsers'
    'click #user-and-group-to-select .user-and-group-search--clean': 'cleanUsersToSelectSearch'
    'click #user-and-group-selection .user-and-group-search--clean': 'cleanSelectedUsersSearch'
    'click .user-and-group-selection__actions--copy-button': 'copySelection'

  initialize: (@options = {}) =>
    @users = @options.users
    @userGroups = @options.user_groups

  render: =>
    @$el.html(@template(@options))

  selectAllOptionsIn: (side) =>
    @$el.find(side).find('li:visible').addClass('ui-selected')

  addSelectedUsers: =>
    @moveSelectedOptions('#user-and-group-to-select', '#user-and-group-selection')

  removeSelectedUsers: =>
    @moveSelectedOptions('#user-and-group-selection', '#user-and-group-to-select')

  moveSelectedOptions: (from, to) =>
    selectedGroups = @$el.find(from).find('li.ui-selected.user-group-filter-option:visible')
    selectedUsers = @$el.find(from).find('li.ui-selected.user-filter-option:visible')
    @$el.find("#{to} .user-group-options").append(selectedGroups.removeClass('ui-selected').show())
    @$el.find("#{to} .user-options").append(selectedUsers.removeClass('ui-selected').show())

  addExpandedUsers: =>
    @moveExpandedOptions('#user-and-group-to-select', '#user-and-group-selection')

  removeExpandedUsers: =>
    @moveExpandedOptions('#user-and-group-selection', '#user-and-group-to-select')

  moveExpandedOptions: (from, to) =>
    selectedUsers = @$el.find(from).find('li.ui-selected.user-filter-option:visible')
    @$el.find("#{to} .user-options").append(selectedUsers.removeClass('ui-selected').show())

    selectedGroups = @$el.find(from).find('li.ui-selected.user-group-filter-option:visible')
    selectedGroups.each (i, el) =>
      groupUserIds = $(el).data('user-ids') or []
      for userId in groupUserIds
        $userEl = @$el.find("#{from} li.user-filter-option[value='#{userId}']")
        if $userEl.length > 0
          @$el.find("#{to} .user-options").append($userEl.removeClass('ui-selected').show())
    selectedGroups.removeClass('ui-selected')

  addAllUsers: =>
    @selectAllOptionsIn('#user-and-group-to-select')
    @addSelectedUsers()

  removeAllUsers: =>
    @selectAllOptionsIn('#user-and-group-selection')
    @removeSelectedUsers()

  filterList: (containerSelector, query) ->
    query = query.toLowerCase()
    $list = @$el.find(containerSelector)

    # si termina en coma o está vacía → mostrar todo
    if query.trim() == '' or query.trim().endsWith(',')
      $list.find('li').show()
      return

    queries = query.split(',').map((q) -> q.trim()).filter((q) -> q.length > 0)

    $list.find('li').each (i, el) ->
      $el = $(el)
      text = $el.text().toLowerCase()
      match = false

      for q in queries
        if text.indexOf(q) >= 0
          match = true
          break

      if match
        $el.show()
      else
        $el.hide()

  searchUsersToSelect: (e) ->
    query = $(e.currentTarget).val().toLowerCase()
    @filterList('#user-and-group-to-select', query)

  searchSelectedUsers: (e) ->
    query = $(e.currentTarget).val().toLowerCase()
    @filterList('#user-and-group-selection', query)

  cleanUsersToSelectSearch: ->
    $input = @$el.find('#user-and-group-to-select .user-and-group-search--input')
    $input.val('')
    @$el.find('#user-and-group-to-select li').show()

  cleanSelectedUsersSearch: ->
    $input = @$el.find('#user-and-group-selection .user-and-group-search--input')
    $input.val('')
    @$el.find('#user-and-group-selection li').show()

  copySelection: ->
    $items = @$el.find('#user-and-group-selection li')
    names = []

    $items.each (i, el) ->
      names.push($(el).text().trim())

    textToCopy = names.join(', ')
    $btn = @$el.find('.user-and-group-selection__actions--copy-button')
    originalColor = $btn.css('color')

    @copyText(textToCopy).then =>
      $btn.css('color', 'green')
      setTimeout (-> $btn.css('color', originalColor)), 800
    .catch (err) ->
      console.error('Error al copiar:', err)
      console.log('Texto a copiar:', textToCopy)

  copyText: (text) ->
    new Promise (resolve, reject) ->
      if navigator.clipboard and window.isSecureContext
        navigator.clipboard.writeText(text).then(resolve).catch(reject)
      else
        try
          temp = $('<textarea>')
          $('body').append(temp)
          temp.val(text).select()
          document.execCommand('copy')
          temp.remove()
          resolve()
        catch err
          reject(err)
